import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiGrid from '@material-ui/core/Grid';
import MuiBox from '@material-ui/core/Box';
import { useQuery } from 'react-query';
import * as API from 'api';
import MuiCircularProgress from '@material-ui/core/CircularProgress';

import DualListBox from '../../../components/DualListBox';
const Party = API.Parties();
const styles = _theme => ({
  bold: {
    fontWeight: 'bold',
  },
});

function AddRemoveTrack({ ...props }) {
  const [trackOptions, setTrackOptions] = useState([]);

  const { classes, labelId, updateForm, formData } = props;
  const { isLoading } = useQuery(
    ['accountTracks', { label: labelId }],
    () => Party.getFromGroupWithReleasesAndTracks(labelId),
    {
      onSuccess: parties => {
        setTrackOptions(
          parties
            .filter(party => party.releaseParties?.length)
            .map(party => ({
              label: party.full_name,
              options: party.releaseParties.map(rP => ({
                label: rP.release.title,
                options: rP.release.releaseSets
                  .map(rs => [
                    rs.setTracks.map(st => ({
                      label: `${st.track.title}${st.track.resource_type === 'Video' ? ' [Video]' : ''}`,
                      value: st.track.id,
                      isrc: st.track.isrc_code,
                      artists: party.full_name,
                    })),
                  ])
                  .flat(3),
              })),
            }))
        );
      },
    }
  );

  function handleChanges(_evt, values) {
    updateForm({
      target: {
        value: values.map(v => ({ id: v.value })),
        id: 'accountTracks',
      },
    });
  }

  return (
    <>
      <MuiGrid item xs={3}>
        <span className={classes.bold}>Add Tracks To Recoupment Account</span>
        <p>
          Please select the tracks or releases that would recouped against.
          <br />
          Only tracks (ISRCS) in the delivered state are in the list to the right.
        </p>
      </MuiGrid>
      <MuiGrid item xs={6}>
        <MuiBox>
          {isLoading ? (
            <MuiCircularProgress />
          ) : trackOptions.length === 0 ? (
            <MuiBox>This Label has no associated tracks.</MuiBox>
          ) : (
            <DualListBox
              id="tracks"
              options={trackOptions}
              //formData wants id but DuelLists wants value. This changes bases on
              //if it is an edit or a create and the status of user actions
              selected={formData?.accountTracks?.map(t => ({ value: t.id || t.value })) || []}
              onChange={handleChanges}
              filterPlaceholder="Filter by Artists, Release, Track, ISRC"
            />
          )}
        </MuiBox>
      </MuiGrid>
    </>
  );
}

export default withStyles(styles)(AddRemoveTrack);
